import styled from "styled-components";

export const OptionsWraper = styled.div`
  & .ant-select-item-option-selected{
    background-color: transparent !important;
    font-weight: normal !important;
  }
`;

export const PurchaseRuleBox = styled.div`
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 6px;
  padding: 4px;
  & .btn-bottom{
    margin: 4px 0;
  }
`